export class AuthError extends Error {
  constructor(message?: string) {
    super(message);

    this.name = 'AuthError';

    if (Error.captureStackTrace) Error.captureStackTrace(this, AuthError);
  }
}
